import { render, staticRenderFns } from "./CodingRequestAcute.vue?vue&type=template&id=350f5265&scoped=true&"
import script from "./CodingRequestAcute.vue?vue&type=script&lang=js&"
export * from "./CodingRequestAcute.vue?vue&type=script&lang=js&"
import style0 from "./CodingRequestAcute.vue?vue&type=style&index=0&id=350f5265&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350f5265",
  null
  
)

export default component.exports